export const BACKUP_CODES_TITLE_ID = 'backup-codes-title';
export const BACKUP_CODES_DESCRIPTION_ID = 'backup-codes-description';
